import { ExpandMore } from '@mui/icons-material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  Container,
  Skeleton,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import ModalVideo from 'react-modal-video';
import { useFAQ } from '../../api';
import AppBar from '../../app-bar/AppBar';
import Breadcrumbs from '../../breadcrumbs/Breadcrumbs';

const FAQ = () => {
  const { data, isLoading, error } = useFAQ();
  const [activeVideo, setActiveVideo] = useState({
    isOpen: {},
  });

  return (
    <>
      <AppBar title="Contact support" />
      <Breadcrumbs
        items={[{ label: 'Home', to: '/' }, { label: 'Help center', to: '/help-center' }, { label: 'FAQ' }]}
        sx={{ display: { xs: 'none', sm: 'flex' } }}
      />

      <Container>
        <Typography variant="h3" pt={7} mb={3}>
          FAQs
        </Typography>
        {isLoading ? (
          <>
            <Skeleton height={100} />
            <Skeleton height={100} />
            <Skeleton height={100} />
            <Skeleton height={100} />
            <Skeleton height={100} />
          </>
        ) : error ? (
          <p>Oops something went wrong.</p>
        ) : (
          data?.map(categories => (
            <Card sx={{ mb: 3 }} key={categories.category}>
              <Accordion expanded key={categories.category}>
                <Typography
                  component="h1"
                  sx={theme => ({
                    p: '20px 16px',
                    fontSize: '1.1rem',
                    borderBottom: `1px solid ${theme.palette.divider}`,
                    background: theme.palette.surfaces.background,
                    color: 'white',
                  })}
                  variant="subtitle1"
                >
                  {categories.category}
                </Typography>
                {categories.items?.map((item, key) => (
                  <AccordionDetails
                    key={item.title}
                    sx={theme => ({
                      borderBottom: `1px solid ${theme.palette.divider}`,
                      p: '8px 16px',
                    })}
                  >
                    <Accordion
                      sx={{
                        '&:before': {
                          display: 'none',
                        },
                      }}
                      key={item.title}
                      elevation={0}
                    >
                      <AccordionSummary sx={{ p: 0 }} expandIcon={<ExpandMore />}>
                        <Box display="flex" alignItems="center" justifyContent="space-between" flex={1}>
                          <Typography component="h3">{item.title}</Typography>
                        </Box>
                      </AccordionSummary>

                      <AccordionDetails sx={{ position: 'relative', fontStyle: 'italic' }}>
                        {/* @TODO Show only MP4 for now, no design for other type of attachments like images */}
                        {item?.url && item?.url.includes('mp4') && (
                          <>
                            <ModalVideo
                              videoId={item.url}
                              channel="custom"
                              url={item.url}
                              autoplay={false}
                              isOpen={activeVideo.isOpen[`${categories.category}${key}`]}
                              onClose={() =>
                                setActiveVideo({
                                  ...activeVideo,
                                  ...{
                                    isOpen: {
                                      [`${categories.category}${key}`]: false,
                                    },
                                  },
                                })
                              }
                            />

                            <Box
                              sx={{
                                cursor: 'pointer',
                                display: 'inline',
                                float: 'left',
                                height: '67px',
                                width: '130px',
                              }}
                              onClick={() =>
                                setActiveVideo({
                                  ...activeVideo,
                                  ...{
                                    isOpen: {
                                      [`${categories.category}${key}`]: true,
                                    },
                                  },
                                })
                              }
                            >
                              <video
                                style={{
                                  width: '120px',
                                }}
                              >
                                <source src={`${item?.url}#t=${item?.thumbnail}`} />
                              </video>
                              <PlayArrowIcon
                                sx={{
                                  color: 'white',
                                  cursor: 'pointer',
                                  fontSize: '43px',
                                  left: '54px',
                                  position: 'absolute',
                                  top: '23px',
                                }}
                              />
                            </Box>
                          </>
                        )}
                        {item.description}
                      </AccordionDetails>
                    </Accordion>
                  </AccordionDetails>
                ))}
              </Accordion>
            </Card>
          ))
        )}
      </Container>
    </>
  );
};

export default FAQ;
